import React from 'react';
import { GenericRadio } from 'web-ui-components/lib/data/capture';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { StandoutTile } from 'web-ui-components/lib/layout/content';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';
import { isRequired } from '../../../utils/validation';

const SwitchMailing = ({ values }) => (
  <Content>
    {({
      switchBusinessSwitchMailingLabel,
      switchBusinessSwitchMailingValidationMessage,
      switchBusinessSwitchMailingValue1 = '',
      switchBusinessSwitchMailingValue2 = '',
      switchBusinessSwitchMailingMessage
    }) => (
      <div>
        <Field
          name="switchMailing"
          subscription={{ touched: true, error: true }}
          validate={isRequired}
        >
          {({ meta: { touched, error }, input }) => (
            <GenericFieldWrapper
              inputId="switchMailing"
              title={switchBusinessSwitchMailingLabel}
              validationMessage={
                touched && !!error ? switchBusinessSwitchMailingValidationMessage : ''
              }
            >
              <GenericRadio.InlineSet
                groupName="switchMailing"
                items={[
                  {
                    id: switchBusinessSwitchMailingValue1,
                    labelText: switchBusinessSwitchMailingValue1
                  },
                  {
                    id: switchBusinessSwitchMailingValue2,
                    labelText: switchBusinessSwitchMailingValue2
                  }
                ]}
                {...input}
                selectedId={values.switchMailing}
              />
            </GenericFieldWrapper>
          )}
        </Field>
        {values.switchMailing === switchBusinessSwitchMailingValue2 && (
          <StandoutTile.Important>
            <p>{switchBusinessSwitchMailingMessage}</p>
          </StandoutTile.Important>
        )}
      </div>
    )}
  </Content>
);

export default SwitchMailing;
